export default __webpack_public_path__ + "Neutraface2Text-Light.woff";